export const BRAND = {
  name: "Skloccom",
  phone: "4388007411",
  phoneDisplay: "(438) 800-7411",
  email: "chris@skloccom.com",
  location: "Southern Ontario, Canada",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1501520158826-76df880863a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1558904541-efa843a96f01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
  cta: "https://images.unsplash.com/photo-1464295440335-ee082a75ccca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "grass-cutting",
    title: "Precision Grass Cutting",
    type: "Residential & Commercial",
    pricing: "$45 – $80 / visit",
    pricingNote: "Volume tiers for estates & commercial acreage",
    description:
      "Weekly or bi-weekly manicured cuts with razor edging, boundary string trimming, and a full power-blow of every hard surface.",
    features: ["Laser edge definition", "Mulch or bag collection", "Debris blown clean", "Seasonal blade calibration"],
    image: "https://images.unsplash.com/photo-1734303023491-db8037a21f09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxnYXJkZW5lciUyMGxhbmRzY2FwaW5nJTIwdGVhbXxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: [45, 80],
  },
  {
    id: "sodding",
    title: "Instant Sodding & Turf Replacement",
    type: "Property Restoration",
    pricing: "In-person custom estimate",
    pricingNote: "Includes soil testing & weed eradication",
    description:
      "Grade-A Kentucky Bluegrass and Fescue blends laid over fresh compost-enriched triple mix for an overnight transformation.",
    features: ["Old turf excavation", "Grade levelling & rolling", "Root starter fertilizer", "21-day watering program"],
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: null,
  },
  {
    id: "seeding",
    title: "Overseeding & Aeration Therapy",
    type: "Lawn Density",
    pricing: "$180 / yard, seed included",
    pricingNote: "High-germination cultivars for the Canadian climate",
    description:
      "Core plug aeration paired with certified drought-resistant seed broadcasting to thicken turf and choke weeds out naturally.",
    features: ["Double-pass core aeration", "Organic top-dressing", "Endophyte-enhanced blends", "Deep root nourishment"],
    image: "https://images.unsplash.com/photo-1540470174401-f25e9eb17c1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: [180, 260],
  },
  {
    id: "gardens",
    title: "Curated Garden Design & Care",
    type: "Estate Horticulture",
    pricing: "Tailored consultation",
    pricingNote: "Seasonal contracts or single transformations",
    description:
      "Bespoke perennial bed installations, shrub rejuvenation, organic pest defence and soil enrichment that matures beautifully.",
    features: ["Native Ontario pollinators", "Architectural shrub placement", "Organic slow-release feeding", "Ongoing deadheading & weeding"],
    image: "https://images.unsplash.com/photo-1719324923613-ff0884b031ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMHBhdGlvfGVufDB8fHx8MTc5MTYwMzY4M3ww&ixlib=rb-4.1.0&q=85",
    estimate: null,
  },
  {
    id: "mulching",
    title: "Artisan Mulch Bed Installation",
    type: "Soil & Weed Defence",
    pricing: "$125 / cubic yard installed",
    pricingNote: "Midnight black, cedar, hemlock or red pine",
    description:
      "Deep spade-trenched edging finished with three inches of premium aged organic bark to lock in moisture and starve weeds.",
    features: ["Deep spade edge trench", "Optional geo-textile fabric", "100% natural dyes", "Moisture & root protection"],
    image: "https://images.unsplash.com/photo-1605117882932-f9e32b03fea9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxnYXJkZW5lciUyMGxhbmRzY2FwaW5nJTIwdGVhbXxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: [125, 375],
  },
  {
    id: "pruning",
    title: "Shrub Sculpting & Precision Pruning",
    type: "Horticultural Sculpting",
    pricing: "From $65 minimum",
    pricingNote: "Hedges, topiary & small fruit trees",
    description:
      "Seasonal pruning that stimulates dense branching, holds crisp architectural lines and removes diseased growth for good.",
    features: ["Dormant & active season cuts", "Sanitized precision shears", "Crown thinning & shaping", "Full green-waste removal"],
    image: "https://images.unsplash.com/photo-1668189777890-495c36095340?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxnYXJkZW5lciUyMGxhbmRzY2FwaW5nJTIwdGVhbXxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: [65, 150],
  },
  {
    id: "cleanups",
    title: "Spring & Fall Seasonal Cleanups",
    type: "Seasonal Reset",
    pricing: "From $279 minimum",
    pricingNote: "Scaled to property size & leaf volume",
    description:
      "Full property resuscitation: power de-thatching, leaf vacuuming, bed evacuation, cutbacks and pre-winter preparation.",
    features: ["Heavy debris extraction", "Power thatch raking", "Curbside vacuum or haul-away", "Winterization / spring wake-up"],
    image: "https://images.unsplash.com/photo-1734079692160-fcbe4be6ab96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxnYXJkZW5lciUyMGxhbmRzY2FwaW5nJTIwdGVhbXxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: [279, 450],
  },
  {
    id: "interlocking",
    title: "Interlocking, Patios & Concrete",
    type: "Hardscaping & Masonry",
    pricing: "Custom architectural quote",
    pricingNote: "Engineered base built for freeze-thaw cycles",
    description:
      "Custom pavers, retaining walls, walkways and fire-pit patios on compacted aggregate foundations that refuse to shift.",
    features: ["Laser excavation & compaction", "Polymeric joint stabilization", "Soldier-course borders", "Full drainage integration"],
    image: "https://images.unsplash.com/photo-1761637823293-f96835ec5038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMHBhdGlvfGVufDB8fHx8MTc5MTYwMzY4M3ww&ixlib=rb-4.1.0&q=85",
    estimate: null,
  },
  {
    id: "snow-removal",
    title: "Winter Snow & Ice Management",
    type: "Year-Round Protection",
    pricing: "Seasonal contract / per event",
    pricingNote: "Commercial lots, driveways & walkways",
    description:
      "Zero-tolerance clearing, eco-friendly ice melt and rapid dispatch through every Ontario blizzard, all season long.",
    features: ["24/7 storm monitoring", "Under 2-inch trigger dispatch", "Paw-safe eco salting", "Dedicated snow staking"],
    image: "https://images.unsplash.com/photo-1464295440335-ee082a75ccca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    estimate: null,
  },
];

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1761637823293-f96835ec5038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMHBhdGlvfGVufDB8fHx8MTc5MTYwMzY4M3ww&ixlib=rb-4.1.0&q=85",
    title: "Curved Stone Hardscaping & Retaining Wall",
    category: "Interlocking & Stone",
    scope: "Oakville Residence, 2024",
  },
  {
    url: "https://images.unsplash.com/photo-1501520158826-76df880863a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXNoJTIwbWFuaWN1cmVkJTIwbGF3bnxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    title: "Estate Diamond Striping & Turf Restoration",
    category: "Lawn Care",
    scope: "Burlington Estate, 2024",
  },
  {
    url: "https://images.unsplash.com/photo-1711098256574-7b497260cdc9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMHBhdGlvfGVufDB8fHx8MTc5MTYwMzY4M3ww&ixlib=rb-4.1.0&q=85",
    title: "Natural Sandstone Patio Living Space",
    category: "Outdoor Living",
    scope: "Hamilton Hills, 2023",
  },
  {
    url: "https://images.unsplash.com/photo-1734079692147-c6fc9438a2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMHBhdGlvfGVufDB8fHx8MTc5MTYwMzY4M3ww&ixlib=rb-4.1.0&q=85",
    title: "Cedar Deck Integration at the Forest Edge",
    category: "Outdoor Living",
    scope: "Dundas Valley, 2024",
  },
  {
    url: "https://images.unsplash.com/photo-1668189777890-495c36095340?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxnYXJkZW5lciUyMGxhbmRzY2FwaW5nJTIwdGVhbXxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
    title: "Formal Hedge & Topiary Sculpting",
    category: "Pruning & Tree Care",
    scope: "Ancaster Manor, 2024",
  },
  {
    url: "https://images.unsplash.com/photo-1719324923613-ff0884b031ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMHBhdGlvfGVufDB8fHx8MTc5MTYwMzY4M3ww&ixlib=rb-4.1.0&q=85",
    title: "Sunken Lounge & Perimeter Boxwoods",
    category: "Garden Design",
    scope: "Waterdown Residence, 2024",
  },
];

export const TEAM = [
  {
    name: "Chris",
    role: "Founder & Lead Landscaper",
    bio: "Started cutting neighbourhood lawns at 19 and never lost the itch. Founded Skloccom in 2022 to bring obsessive, detail-first lawn craft to Ontario properties — every edge crisp, every visit on time.",
    avatar: "https://images.unsplash.com/photo-1605117882932-f9e32b03fea9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxnYXJkZW5lciUyMGxhbmRzY2FwaW5nJTIwdGVhbXxlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Tania M.",
    role: "Accounts & Billing",
    bio: "Keeps every quote clear and every invoice painless. Transparent pricing, simple digital payments, and zero surprise line items — so you can focus on the yard, not the paperwork.",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHdvbWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkxNjAzNjgzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Maddy R.",
    role: "Scheduling & Client Care",
    bio: "Works around your calendar, not ours. Maddy routes crews around the weather, confirms every visit, and makes booking the easiest part of owning a beautiful property.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHBvcnRyYWl0JTIwc21pbGluZ3xlbnwwfHx8fDE3OTE2MDM2ODN8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const PROMOS = [
  {
    id: "combo",
    headline: "Save $10 on Lawn + Garden Care",
    detail: "Pair recurring lawn cutting with monthly garden bed maintenance and keep an ongoing $10 credit every cycle.",
    badge: "Popular Bundle",
    code: "SKLOC-COMBO10",
    value: 10,
  },
  {
    id: "spring",
    headline: "Save $15 on an Early Spring Reset",
    detail: "Lock in your spring cleanup before April 30th for priority dispatch and an automatic $15 seasonal discount.",
    badge: "Early Bird",
    code: "SKLOC-SPRING15",
    value: 15,
  },
  {
    id: "mulch",
    headline: "Save $10 on Mulch & Planting",
    detail: "Combine premium bark mulch installation with perennial or shrub planting for an instant $10 project saving.",
    badge: "Restoration Special",
    code: "SKLOC-MULCH10",
    value: 10,
  },
];

export const BOOKING_SLOTS = [
  { id: "08-10", label: "8:00 – 10:00 AM" },
  { id: "10-12", label: "10:00 AM – 12:00 PM" },
  { id: "12-14", label: "12:00 – 2:00 PM" },
  { id: "14-16", label: "2:00 – 4:00 PM" },
  { id: "16-18", label: "4:00 – 6:00 PM" },
];

export const TESTIMONIALS = [
  {
    name: "Sarah L.",
    area: "Burlington",
    service: "Sodding & Lawn Care",
    text: "The crew turned our patchy backyard into the best lawn on the street. Edges so sharp our neighbours asked who did it.",
  },
  {
    name: "Marc D.",
    area: "Oakville",
    service: "Spring Cleanup",
    text: "Booked a spring cleanup and they were on time, thorough, and left the beds looking brand new. Booking again for fall.",
  },
  {
    name: "Priya K.",
    area: "Hamilton",
    service: "Interlocking",
    text: "Chris walked the property, explained every option, and the patio came out better than the sketch. Zero mess left behind.",
  },
  {
    name: "Tom W.",
    area: "Ancaster",
    service: "Snow Removal",
    text: "Signed up for the winter contract after one storm. The driveway was clear before we even woke up. Worth every penny.",
  },
];
